import { applyMiddleware, combineReducers, compose, createStore } from "redux";

import reducers from "../reducers";
import thunk from "redux-thunk";

export default function configureStore() {
  return createStore(
    combineReducers({
      ...reducers
    }),
    {},
    compose(
      compose(
        applyMiddleware(thunk),
        ...(window.__REDUX_DEVTOOLS_EXTENSION__
          ? [window.__REDUX_DEVTOOLS_EXTENSION__()]
          : [])
      )
    )
  );
}
